import instance, { securedInstance } from "./instance";
import reduxStore from "../redux/store";

const getReduxStateData = () => {
  return reduxStore.getState().renewal;
};

export const getUserDetails = async (data) => {
  const request = { ...data, infoFlag: "false", yob: getReduxStateData().yob };
  return instance.post("/userDetailsFromLink", request, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getRenewalList = async (data) => {
  const request = { ...data, infoFlag: "false" };
  return instance.post("/getRenewalList", request, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getQuotationDetails = async (data) => {
  const request = { ...data };
  return securedInstance.post("/getQuotationDetails", request, {
    headers: {
      "Content-Type": "application/json",
      tawuniyaLead: false,
    },
  });
};

export const getCustomerDetails = async (data) => {
  const request = { ...data, infoFlag: "false", yob: getReduxStateData().yob };
  return securedInstance.post("/getCustomerDetails", request, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getDriverDetailsRequest = (data) => {
  return securedInstance.post("getDriverDetails", data, {
    headers: {
      "Content-Type": "application/json",
      tawuniyaLead: false,
    },
  });
};

export const getProposalDetails = async (data) => {
  const request = { ...data };
  return securedInstance.post("/getProposal", request, {
    headers: {
      "Content-Type": "application/json",
      sourceCodeType: data.endorsementType === "PSL" ? "upgrade" : "renew",
    },
  });
};

export const getDefaultValues = async (data) => {
  const request = { ...data };
  return instance.post("/getDefaultValues", request, {
    headers: { "Content-Type": "application/json" },
  });
};

export const createQuotation = async (data) => {
  const request = { ...data };
  return securedInstance.post("/createQuotation", request, {
    headers: { "Content-Type": "application/json", sourceCodeType: "upgrade" },
  });
};

export const renewQuotation = async (data) => {
  const request = { ...data };
  return securedInstance.post("/getRenewPolicy", request, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getCardPayment = async (data) => {
  const request = { ...data };
  request.source.type = "token";
  return instance.post("/payment/getCardPayment", request, {
    headers: { "Content-Type": "application/json" },
  });
};
export const getPaymentById = async (data) => {
  return instance.post("/payment/getPaymentById", data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const getSadadPayment = async (data) => {
  return instance.post("/payment/getSadadPaymentGeneration", data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const createTamaraSession = async (data) => {
  return instance.post("/createSession", data, {
    headers: { "Content-Type": "application/json" },
  });
};
export const verifyTamaraOrder = async (data) => {
  return instance.post("/verifyOrder", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const verifyClient = async (data) => {
  return instance.post("/verifyClient", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const sendOTP = async (data) => {
  return instance.post("/travel/sendOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const validateOTP = async (data) => {
  return instance.post("/travel/validateOTP", data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getMotorColor = async (data) => {
  return instance.post("/common/getColor", data, {
    headers: { "Content-Type": "application/json" },
  });
};
